import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { branding } from '../../../branding';
import { PATHS } from '../constants';
import {
  Logo,
  InfoIcon,
  WelcomeContent,
  Wrapper,
  WelcomeImage,
  WelcomeScreenContainer,
  WelcomeText,
  HeaderText,
  DescriptionText,
  BackButton,
} from '../welcome-screen-components';

const RequestPasswordResetConfirmation: FC = () => {
  const navigate = useNavigate();

  return (
    <WelcomeScreenContainer>
      <WelcomeImage />
      <WelcomeContent>
        <Wrapper>
          <Logo src={branding.logo as string} />
          <InfoIcon src="/public/icons/instructions-sent-icon.svg" />
          <WelcomeText>
            <HeaderText>Instructions sent</HeaderText>
            <DescriptionText>Check your email for password reset instructions</DescriptionText>
          </WelcomeText>
          <BackButton size="lg" onClick={() => navigate(PATHS.LOGIN)} mr={16}>
              Back to Sign in
          </BackButton>
        </Wrapper>
      </WelcomeContent>
    </WelcomeScreenContainer>
  );
};

export default RequestPasswordResetConfirmation;
